export default {
  kichen: {
    complex_dinners: {
      name: "комплексні обіди з 12:00 до 15:00",
      photo: "complex.jpg",
    },
    snidanok: {
      name: "Сніданки",
      photo: "snidanok.jpg",
    },
    salat: {
      name: "Салати",
      photo: "salat.jpg",
    },
    firstEat: {
      name: "Перші страви",
      photo: "firstEat.JPG",
    },
    bruscets: {
      name: "Брускети",
      photo: "brusket.JPG",
    },
    coldEat: {
      name: "Закуски",
      photo: "coldEat.jpg",
    },
    hotEat: {
      name: "Закуски до пива",
      photo: "hotEat.jpg",
    },
    odessaDelicateses: {
      name: "Одеські делікатеси",
      photo: "odessaDelicateses.jpg",
    },
    main: {
      name: "Основні страви",
      photo: "main.JPG",
    },
    burgers: {
      name: "Бургери",
      photo: "burgers.JPG",
    },
    garnirs: {
      name: "Гарніри",
      photo: "garnirs.jpg",
    },
    // forCompanies: {
    //   name: "Для компанії",
    //   photo: "forCompanies.JPG",
    // },
    deserts: {
      name: "Десерти",
      photo: "deserts.JPG",
    },
    додатки: {
      name: "Додатки",
      photo: "dodatki.jpeg",
    },
  },
  bar: {
    coffe: {
      name: "Кава",
      photo: "coffe.jpg",
    },
    tia: {
      name: "Чаї",
      photo: "tia.jpg",
    },
    nonAlcohol: {
      name: "Безалкогольні напої",
      photo: "not-alcohol1.jpg",
    },
    alcohol: {
      name: "Алкоголь",
      photo: "alcohol.jpg",
    },
    coctails: {
      name: "Коктейлі",
      photo: "coctails.jpg",
    },
  },
  // sushi: {
  //   seti: {
  //     name: "сети",
  //     photo: "seti.jpeg",
  //   },
  //   FILADELFIYA: {
  //     name: "філадельфія",
  //     photo: "filadelfiya.jpg",
  //   },
  //   dragons: {
  //     name: "дракони",
  //     photo: "drakon.jpeg",
  //   },
  //   premium: {
  //     name: "преміум",
  //     photo: "premium.jpg",
  //   },
  //   kalifornia: {
  //     name: "КАЛІФОРНІЯ",
  //     photo: "kalifornia.jpeg",
  //   },
  //   roli: {
  //     name: "роли",
  //     photo: "roli.jpeg",
  //   },
  //   maki: {
  //     name: "МАКІ",
  //     photo: "maki.jpeg",
  //   },
  //   gunkan: {
  //     name: "ГУНКАН",
  //     photo: "gunkan.jpeg",
  //   },
  //   nigiri: {
  //     name: "НІГІРІ",
  //     photo: "nigiri.jpeg",
  //   },
  // },
  tia: {
    "Заварні чаї": {
      name: "Заварні чаї",
      photo: "tia3.jpeg",
    },
    "Порційні чаї": {
      name: "Порційні чаї",
      photo: "tia.jpg",
    },
    "Чаї власного виробництва": {
      name: "Чаї власного виробництва",
      photo: "tia2.jpg",
    },
  },
  nonAlcohol: {
    лимонади: {
      name: "лимонади",
      photo: "not-alcohol1.jpg",
    },
    "Домашні Закрутки": {
      name: "Домашні Закрутки",
      photo: "not-alcohol7.jpg",
    },
    фреші: {
      name: "фреші",
      photo: "not-alcohol2.jpeg",
    },
    "молочні коктейлі": {
      name: "молочні коктейлі",
      photo: "not-alcohol3.jpg",
    },
    "б/а напої": {
      name: "б/а напої",
      photo: "non-alcogol.jpg",
    },
    "б/а коктейлі": {
      name: "б/а коктейлі",
      photo: "not-alcohol5.jpeg",
    },
    "зігріваючі напої": {
      name: "зігріваючі напої",
      photo: "not-alcohol6.jpg",
    },
  },
  alcohol: {
    rom: {
      name: "Ром",
      photo: "alcohol1.jpeg",
    },
    tekila: {
      name: "Текіла",
      photo: "alcohol2.jpeg",
    },
    vodka: {
      name: "Горілка",
      photo: "alcohol3.jpg",
    },
    viskey: {
      name: "Віскі",
      photo: "alcohol.jpg",
    },
    liker: {
      name: "Лікери та Настоянки",
      photo: "alcohol4.jpeg",
    },
    bear: {
      name: "Пиво",
      photo: "alcohol5.jpg",
    },
    white_wine: {
      name: "Білі Вина",
      photo: "alcohol6.jpeg",
    },
    red_wine: {
      name: "Червоні Вина",
      photo: "alcohol7.jpeg",
    },
    igrist_wine: {
      name: "Ігристі Вина",
      photo: "alcohol11.jpg",
    },
    jin: {
      name: "Джин",
      photo: "alcohol8.jpg",
    },
    brendy: {
      name: "Коньяк",
      photo: "alcohol9.jpeg",
    },
    nastoyanki: {
      name: "Крафтові Настоянки",
      photo: "alcohol10.jpg",
    },
  },
  coctails: {
    "Гарячі коктейлі": {
      name: "Гарячі коктейлі",
      photo: "coctails1.jpg",
    },
    "Холодні коктейлі": {
      name: "Холодні коктейлі",
      photo: "coctails.jpg",
    },
    Шоти: {
      name: "Шоти",
      photo: "shots.jpg",
    },
  },
  delivery: {
    Glovo: {
      name: "Glovo",
      photo: "glovo.png",
      href: "https://glovoapp.com/ua/uk/ivano-frankivsk/hastrobar-balkon-ivf/",
    },
    MrAm: {
      name: "Mr.Am",
      photo: "mrAm.png",
      href: "https://misteram.com.ua/frankivsk/balkon",
    },
  },
};
